"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithDefaults = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var defaults_1 = require("./defaults");

var Control_1 = require("./Control");

var Parameters_1 = require("./Parameters");

var metrics_1 = require("../../utils/metrics");

exports.WithDefaults = function (_a) {
  var children = _a.children,
      options = tslib_1.__rest(_a, ["children"]);

  var params = tslib_1.__assign(tslib_1.__assign({}, defaults_1.defaultOptions), options);

  var CAParams = params.CAParams,
      helpLinks = params.helpLinks,
      modalOptions = params.modalOptions,
      trackEvent = params.trackEvent;
  var view = params.view,
      loaderShowDelay = params.loaderShowDelay; // Проставляем "сложные" дефолтные параметры

  var CAParamsInternal;

  if (CAParams) {
    CAParamsInternal = tslib_1.__assign({
      issuers: [],
      fetchPeriod: 30000,
      thumbprintPerRequest: 100,
      maxErrorCount: 1,
      useCachedStatus: true,
      showWithoutStatus: true,
      visiblePeriodByCAStatus: {},
      sortByStatus: false,
      howToUpdateCertificateLink: 'https://www.kontur-extern.ru/support/faq/32/515',
      whyReissueCertOnGost2012In2020Link: 'https://ca.kontur.ru/faq/teh/chto-s-podpisy-po-gost-2001',
      heraclesProlongationUrl: 'https://certs.kontur.ru/certificate/{{thumbprint}}',
      heraclesReissueUrl: 'https://certs.kontur.ru/reissue/{{thumbprint}}',
      heraclesFreeProlongationUrl: 'https://certs.kontur.ru/freeprolong/{{thumbprint}}',
      heraclesExternalCACertReissueUrl: 'https://ca.kontur.ru/?thumbprint={{thumbprint}}',
      heraclesARMRedirectUrl: 'https://certs.kontur.ru/api/kstoreBridge/prolongation/{{thumbprint}}/cart'
    }, CAParams);
  }

  var helpLinksInternal = tslib_1.__assign({
    howToInstallCertificate: 'http://www.kontur-extern.ru/support/faq/34/62',
    howToCopyPrivateKeyContainer: 'http://www.kontur-extern.ru/support/faq/34/61'
  }, helpLinks);

  var modalOptionsInternal;

  if (modalOptions) {
    modalOptionsInternal = tslib_1.__assign({
      caption: 'Выбор сертификата',
      width: 420,
      ignoreBackgroundClick: false
    }, modalOptions); // Если задан параметр modalView, то и view ставим в Modal.

    view = Parameters_1.CertificatesListView.Modal; // Задержка показа лоадера в модалке не нужна. Возможно и вообще не нужна.

    loaderShowDelay = 0;
  }

  var prefiledTrackEvent = metrics_1.createPrefiledTrackEvent(trackEvent);
  return react_1.default.createElement(Control_1.Control, tslib_1.__assign({}, params, {
    CAParams: CAParamsInternal,
    view: view,
    modalOptions: modalOptionsInternal,
    helpLinks: helpLinksInternal,
    loaderShowDelay: loaderShowDelay,
    trackEvent: prefiledTrackEvent
  }));
};